import Resizer from 'react-image-file-resizer';

export const resizeFile = ( file ) => new Promise(( resolve ) => {
  Resizer.imageFileResizer(file, 640, 900, 'JPG', 80, 0, ( uri ) => {
    resolve(uri);
  });
});
